import styled, { css } from 'styled-components';
import {
  Menu as SemanticMenu,
} from 'semantic-ui-react';

import { Tabs } from './index';

export const Container = styled.div`
  margin-top: 80px;
  padding: 20px 50px;
  display: flex;
`;

export const Menu = styled(SemanticMenu)`
  &&& {
    &.active {
      background-color: #FCFCFC;
    }
    &.menu .active.item {
      background-color: #FCFCFC;
      color: #477AE9;
    }
  }
`;

export const VerticalMenuContainer = styled.div`
`;

export const ContentContainer = styled.div`
  margin-left: 45px;
  ${({ activeItem }) => css`
    width: ${activeItem === Tabs.USAGE || activeItem === Tabs.TEAM ? '100%' : 'auto'};
    overflow-x: ${activeItem === Tabs.BILLING ? 'hidden' : 'auto'};
  `}
  white-space: nowrap;
  overflow-y: auto;
`;
